import { TmTransportError } from '@/core/error/transport/tmTransportError'
import type { InternalErrorResponseBase, TmAxiosResponse } from '@/services/transport/types'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

interface TmApiErrorApiMethodInfo {
  method?: string
  url?: string
}

export abstract class TmApiError<
  T extends Record<any, any> = TmAxiosResponse<InternalErrorResponseBase>,
> extends TmTransportError<T> {
  private apiMethodInfo: TmApiErrorApiMethodInfo | null = null

  public name = 'TmApiError'

  public getApiMethodInfo() {
    return this.apiMethodInfo
  }

  public setApiMethodInfo(info: TmApiErrorApiMethodInfo) {
    this.apiMethodInfo = info
  }

  protected code: TmTransportHttpErrorCode
}
